import { makeStyles } from "@material-ui/core/styles";

export const usePdfScheduleStyles = makeStyles((theme) => ({
  mainHead: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  logoBox: {
    margin: theme.spacing(1),
  },
  table: {
    width: "100%",
    background: "white",
  },
  tableHeadCell: {
    padding: "4px 6px",
    borderTop: "1px solid #BEBFC0",
    borderBottom: "1px solid #BEBFC0",
    height: 36,
    fontSize: 14,
    fontWeight: 600,
  },
  tableHeadDateCell: {
    minWidth: 88,
    padding: 0,
    borderTop: "1px solid #BEBFC0",
    borderBottom: "1px solid #BEBFC0",
  },
  dateHeadContent: {
    display: "flex",
    flexDirection: "column",
  },
  dateHeadDay: {
    padding: "4px 6px",
    textTransform: "uppercase",
  },
  dateHeadDayLabel: {
    fontWeight: 600,
    fontSize: 12,
    whiteSpace: "nowrap",
  },
  dateHeadFooter: {
    padding: "4px 6px",
    borderTop: "#bebfc0 1px solid",
  },
  dateHeadStats: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  dateHeadStat: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  dateHeadStatIcon: {
    "&&": {
      fontSize: 12,
      width: 12,
      height: 12,
    },
  },
  dateHeadStatText: {
    fontSize: 10,
    fontWeight: 500,
  },
  tableCell: {
    whiteSpace: "nowrap",
    height: 48,
    padding: 3,
    boxSizing: "border-box",
    borderBottom: "1px solid #BEBFC0",
  },
  tableBorderLeft: {
    borderLeft: "1px solid #BEBFC0",
  },
  tableBorderRight: {
    borderRight: "1px solid #BEBFC0",
  },
  tableCellContent: {
    padding: "4px",
    fontSize: 12,
    lineHeight: "12px",
  },
  tableFooter: {
  },
  tableFooterCell: {
    borderTop: "1px solid #BEBFC0",
    borderBottom: "1px solid #BEBFC0",
    height: 28,
    padding: "4px 6px",
    boxSizing: "border-box",
    fontSize: 12,
  },
  footerBox: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 2,
  },
  footerIcon: {
    "&&": {
      fontSize: 16,
      width: 16,
      height: 16,
    },
    color: "#5F6164",
  },
  footerText: {
    fontSize: 12,
    fontWeight: 700,
  },
  tenuredCell: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    justifyContent: "flex-end",
  },
  tenuredIcon: {
    color: "#1B7E43",
    "&&": {
      fontSize: 16,
      width: 16,
      height: 16,
    },
  },
  unpublishedIcon: {
    position: "absolute",
    top: 1,
    right: 1,
    "&&": {
      fontSize: 16,
      width: 16,
      height: 16,
    },
  },
  scheduleBox: {
    position: "relative",
    height: 40,
    minWidth: 80,
    borderRadius: 4,
    padding: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  emptyScheduleBox: {
    height: 40,
    minWidth: 80,
    borderRadius: 4,
    padding: 4,
    border: "1px dashed #828487",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  cellContent: {
    padding: "0 2px",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  scheduleHours: {
    opacity: 0.8,
    display: "flex",
    alignItems: "center",
    gap: 2,
  },
  scheduleHoursText: {
    fontSize: "8px !important",
    lineHeight: "10px",
  },
  scheduleHoursIcon: {
    "&&": {
      fontSize: 16,
      width: 16,
      height: 16,
    },
  },
  roleName: {
    fontSize: 12,
    fontWeight: 700,
    lineHeight: "11px",
  },
}));
